var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "app" } },
    [
      _vm.isLoggedIn && _vm.isServerAvailable
        ? _c(
            "b-navbar",
            {
              style: _vm.styleObject,
              attrs: {
                toggleable: "md",
                type: "dark",
                variant: "dark",
                fixed: "top"
              }
            },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-1",
                      modifiers: { "sidebar-1": true }
                    }
                  ],
                  staticClass: "mr-3",
                  attrs: { size: "sm" }
                },
                [_c("font-awesome-icon", { attrs: { icon: ["fas", "bars"] } })],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-brand",
                {
                  directives: [
                    {
                      name: "b-toggle",
                      rawName: "v-b-toggle.sidebar-1",
                      modifiers: { "sidebar-1": true }
                    }
                  ]
                },
                [_vm._v("Рукавица")]
              ),
              _vm._v(" "),
              _c(
                "b-sidebar",
                {
                  attrs: {
                    id: "sidebar-1",
                    title: "Меню",
                    shadow: "",
                    "no-enforce-focus": "",
                    "no-close-on-route-change": "",
                    width: "240px"
                  },
                  model: {
                    value: _vm.isOpenMenu,
                    callback: function($$v) {
                      _vm.isOpenMenu = $$v
                    },
                    expression: "isOpenMenu"
                  }
                },
                [
                  _c(
                    "b-list-group",
                    {
                      staticClass: "menu text-small",
                      attrs: { id: "menu", flush: "" }
                    },
                    [
                      _c(
                        "b-list-group-item",
                        {
                          class:
                            _vm.$route.name === "Home" &&
                            "active router-link-active",
                          attrs: {
                            to: { path: "/home" },
                            variant: _vm.navVariant
                          }
                        },
                        [
                          _c("font-awesome-icon", {
                            staticClass: "mr-1",
                            staticStyle: { color: "darkorange" },
                            attrs: { icon: "home" }
                          }),
                          _vm._v("\n          Личный кабинет\n        ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.hasPermTask
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.name === "Tasks" &&
                                "active router-link-active",
                              attrs: {
                                to: { name: "Tasks" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkgreen" },
                                attrs: { icon: "tasks" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.tasks.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermWorker
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/workers" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/workers" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkblue" },
                                attrs: { icon: "people-carry" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.workers.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCustomer
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/customers" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/customers" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkred" },
                                attrs: { icon: "user-tie" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.customers.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermLocation
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/locations" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/locations" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "green" },
                                attrs: { icon: "map-marked-alt" }
                              }),
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.$t("message.locations.title")) +
                                  "\n        "
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermOrganization
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/organizations" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/organizations" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkred" },
                                attrs: { icon: "building" }
                              }),
                              _vm._v("\n          Организации\n        ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-analytics",
                                  arg: "collapse-analytics"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkorange" },
                                attrs: { icon: "chart-line" }
                              }),
                              _vm._v("\n          Аналитика\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-analytics" } },
                            [
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path ===
                                          "/workers_analytics" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/workers_analytics" }
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "darkorange" },
                                        attrs: { icon: "chart-line" }
                                      }),
                                      _vm._v(
                                        "\n            По исполнителям\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-invoices",
                                  arg: "collapse-invoices"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "darkviolet" },
                                attrs: { icon: "file-invoice-dollar" }
                              }),
                              _vm._v("\n          Счета\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-invoices" } },
                            [
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/invoices" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/invoices" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "darkviolet" },
                                        attrs: { icon: "file-invoice-dollar" }
                                      }),
                                      _vm._v(
                                        "\n            Выставление счёта\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path ===
                                          "/reconciliation_acts" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/reconciliation_acts" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "darksalmon" },
                                        attrs: { icon: "file-contract" }
                                      }),
                                      _vm._v(
                                        "\n            Акты сверки\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermRecruit
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-recruit",
                                  arg: "collapse-recruit"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "royalblue" },
                                attrs: { icon: "people-arrows" }
                              }),
                              _vm._v("\n          Подбор\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-recruit" } },
                            [
                              _vm.hasPermRecruitTask
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/recruit_tasks" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/recruit_tasks" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Заявки")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermRecruitJobPosting
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path ===
                                          "/recruit_job_postings" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/recruit_job_postings" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Объявления")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermLocationVacancy
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path ===
                                          "/recruit_location_vacancies" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: {
                                          path: "/recruit_location_vacancies"
                                        },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [_vm._v("Шаблоны вакансий")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.hasPermStaff
                    ? _c(
                        "b-list-group",
                        {
                          staticClass: "menu text-small",
                          attrs: { flush: "" }
                        },
                        [
                          _c("hr", { staticClass: "m-0" }),
                          _vm._v(" "),
                          _c(
                            "b-list-group-item",
                            {
                              directives: [
                                {
                                  name: "b-toggle",
                                  rawName: "v-b-toggle:collapse-staff",
                                  arg: "collapse-staff"
                                }
                              ],
                              attrs: { variant: _vm.navVariant }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "black" },
                                attrs: { icon: "id-card" }
                              }),
                              _vm._v("\n          ЗУП\n          "),
                              _c(
                                "span",
                                { staticClass: "float-right when-open" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-up", size: "xs" }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "float-right when-closed" },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "chevron-right", size: "xs" }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            { attrs: { id: "collapse-staff" } },
                            [
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/staffs" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/staffs" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "black" },
                                        attrs: { icon: "id-card" }
                                      }),
                                      _vm._v(
                                        "\n            Персонал\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/accruals" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/accruals" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "darkslateblue" },
                                        attrs: { icon: "cash-register" }
                                      }),
                                      _vm._v(
                                        "\n            Начисления зарплаты\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/salaries" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/salaries" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "darkslateblue" },
                                        attrs: { icon: "cash-register" }
                                      }),
                                      _vm._v(
                                        "\n            Выплаты зарплаты\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasPermStaff
                                ? _c(
                                    "b-list-group-item",
                                    {
                                      class:
                                        _vm.$route.path === "/salary_summary" &&
                                        "active router-link-active",
                                      attrs: {
                                        to: { path: "/salary_summary" },
                                        variant: _vm.navVariant
                                      }
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        staticClass: "mr-1",
                                        staticStyle: { color: "darkslateblue" },
                                        attrs: { icon: "cash-register" }
                                      }),
                                      _vm._v(
                                        "\n            Зарплатная ведомость\n          "
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-list-group",
                    { staticClass: "menu text-small", attrs: { flush: "" } },
                    [
                      _c("hr", { staticClass: "m-0" }),
                      _vm._v(" "),
                      _vm.hasPermUser
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/users" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/users" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "users" }
                              }),
                              _vm._v("\n          Пользователи\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermRole
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/user_roles" &&
                                "active router-link-active",
                              attrs: {
                                to: { path: "/user_roles" },
                                variant: _vm.navVariant
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "user-cog" }
                              }),
                              _vm._v("\n          Роли\n        ")
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasPermCatalog
                        ? _c(
                            "b-list-group-item",
                            {
                              class:
                                _vm.$route.path === "/catalogs" &&
                                "active router-link-active",
                              attrs: { to: { path: "/catalogs" } }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                staticStyle: { color: "black" },
                                attrs: { icon: "list" }
                              }),
                              _vm._v("\n          Справочники\n        ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-navbar-nav",
                { staticClass: "ml-auto" },
                [
                  _c(
                    "b-nav-item-dropdown",
                    {
                      attrs: { right: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "button-content",
                            fn: function() {
                              return [_c("em", [_vm._v(_vm._s(_vm.user.name))])]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        210705957
                      )
                    },
                    [
                      _vm._v(" "),
                      _c("b-dropdown-item", { on: { click: _vm.logout } }, [
                        _vm._v(_vm._s(_vm.$t("message.login.logout")))
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : !_vm.isLoggedIn && !_vm.isServerAvailable
        ? _c("div", [_c("router-view")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "navbar-height", style: _vm.styleObject },
        [_c("router-view")],
        1
      ),
      _vm._v(" "),
      _c("ErrorsModalWindow", {
        attrs: {
          offline: _vm.noConnectionError,
          "not-found": _vm.notFoundError,
          forbidden: _vm.forbiddenError
        },
        model: {
          value: _vm.showErrorModal,
          callback: function($$v) {
            _vm.showErrorModal = $$v
          },
          expression: "showErrorModal"
        }
      }),
      _vm._v(" "),
      _c("portal-target", { attrs: { name: "app" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 